import moment from 'moment/moment'
import DescriptionApis from '@/services/apis/description'

const description = new DescriptionApis()
export default {
  data() {
    return {
      termsModal: false,
      termsText: '',
    }
  },
  async mounted() {
    moment.locale(this.$i18n.locale)
    await description.get({ name: 'agreement-register' }).then(res => {
      this.termsText = res.data.results.value
    })
  },
}
